import axios, { type AxiosError, type InternalAxiosRequestConfig } from 'axios';

export const TOKEN_STORAGE_KEY = 'pastpuzzle.token';

const STATUS_UNAUTHORIZED = 401;

export const api = axios.create({
  baseURL: '/api',
  timeout: 15_000,
});

api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = window.localStorage.getItem(TOKEN_STORAGE_KEY);
  if (token) {
    config.headers.set('Authorization', `Bearer ${token}`);
  }
  return config;
});

let onUnauthorized: (() => void) | null = null;

/**
 * Hook für den AuthProvider, um auf 401-Antworten zu reagieren (Token
 * expired oder invalid → Logout + Redirect zur Login-Seite).
 */
export function setUnauthorizedHandler(handler: () => void): void {
  onUnauthorized = handler;
}

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === STATUS_UNAUTHORIZED && onUnauthorized) {
      onUnauthorized();
    }
    return Promise.reject(error);
  },
);
